import { render, staticRenderFns } from "./SportelloFabbricatiIdView.vue?vue&type=template&id=01fb5e5a&"
import script from "./SportelloFabbricatiIdView.vue?vue&type=script&lang=ts&"
export * from "./SportelloFabbricatiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports